import { Close16 } from "@carbon/icons-react";
import { StandardTable, Button, Pagination } from "react3l-ui-library";
import { useMenuReportHistoryList } from "./MenuReportHistoryListHook";
import { useTranslation } from "react-i18next";

function MenuReportHistoryList() {
  const {
    handleGoBack,
    handlePagination,
    requestHistoryList,
    requestHistoryCount,
    columns,
    filter,
  } = useMenuReportHistoryList();

  const [translate] = useTranslation();

  return (
    <div className="page-content page-content-dxg" id={"page-content-dxg-id"}>
      <div className="info-component ml-4 mb-3">
        <span>{translate("menuReports.master.header")}</span>
        <span> &gt; </span>
        <span>{translate("menuReports.master.subHeader")}</span>
        <span> &gt; </span>
        <span className="info-primary">
          {translate("general.actions.listHistory")}
        </span>
      </div>
      <div className="page page-history mt-0">
        <div className="pt-3 pb-1 ml-3 d-flex justify-content-between">
          <h5 className="font-bold page-title">
            {translate("general.actions.listHistory")}
          </h5>
          <div>
            <Button
              type="secondary"
              className="btn--lg btn-red mr-3"
              icon={<Close16 />}
              onClick={handleGoBack}
            >
              {translate("general.actions.close")}
            </Button>
          </div>
        </div>
        <div className="page-history__list">
          <StandardTable
            rowKey={"versionId"}
            columns={columns}
            dataSource={requestHistoryList}
            tableSize={"md"}
            bordered
          />
          <Pagination
            skip={filter?.skip}
            take={filter?.take}
            total={requestHistoryCount}
            onChange={handlePagination}
          />
        </div>
      </div>
    </div>
  );
}

export default MenuReportHistoryList;
